import { Button } from "@/src/components/buttons";
import { Card } from "@/src/components/cards";
import { ColorCircle } from "@/src/components/colorCircle";
import { openDrawer } from "@/src/components/dialogs";
import { FetchableList } from "@/src/components/fetchableLists";
import { AppointmentType } from "@/src/data/allTypes";
import apiFetch from "@/src/utils/apiFetch";
import { getUserId, isCabinet, isHospital, uid } from "@/src/utils/utils";
import { useState } from "react";
import { AppointmentTypeForm } from "./appointmentTypeForm";

export function AppointmentTypesChoiceList({
  currentAppointmentTypes,
  onSelect,
}: {
  currentAppointmentTypes?: (AppointmentType | null | undefined)[];
  onSelect: (newValue: AppointmentType) => void;
}) {
  const [reload, setReload] = useState(0);
  let [searchKey, setSearchKey] = useState<string | null>("");

  async function createNewAppointmentType() {
    let appointmentType: AppointmentType = {
      name: `${searchKey || ""}`,
      demandForm: null,
      duration: 30,
      price: 0,
      color: "RGBA(0, 0, 255, 0.8)",
      creator: getUserId(),
      itemType: "consultation",
    };

    await openDrawer({
      title: "Ajouter un type de rendez-vous",
      content: (
        <AppointmentTypeForm
          current={appointmentType}
          onChange={async (newValue) => {
            appointmentType = newValue;
          }}
        />
      ),
      onConfirm: async () => {
        let type = await apiFetch("appointmentTypes", "addOne", {
          appointmentType,
        });
        setSearchKey("");
        setReload((prev) => prev + 1);
        onSelect(type);
      },
    });
  }

  return (
    <div className="c1 gap10">
      <FetchableList
        queryKey={["AppointmentTypesChoiceList", searchKey, reload]}
        queryFn={() =>
          apiFetch("appointmentTypes", "loadMany", {
            searchKey,
            creatorId: isCabinet() ? getUserId() : null,
            showApi: isHospital() ? true : false,
          })
        }
        searchKey={searchKey}
        onSearch={setSearchKey}
        onClick={async () => {
          await createNewAppointmentType();
        }}
        emptyChild={
          searchKey && (
            <div className="center grid c1 gap10 p20">
              Aucun type de rendez-vous disponible
              <Button
                onClick={async () => {
                  await createNewAppointmentType();
                }}
              >
                <span>
                  Créer <strong>{searchKey}</strong>
                </span>
              </Button>
            </div>
          )
        }
      >
        {(data) => (
          <div className="grid c1 gap10 mtop10">
            {data?.map((appointmentType) => {
              let isActive = currentAppointmentTypes?.find(
                (item) => item?.id === appointmentType.id
              );

              return (
                <Card
                  key={uid()}
                  color={isActive ? "blue" : "simple"}
                  leading={
                    <ColorCircle color={appointmentType.color}></ColorCircle>
                  }
                  title={appointmentType.name}
                  subTitle={appointmentType.description}
                  onClick={async () => {
                    if (isActive)
                      return alert("Ce type de rendez-vous est déjà ajouté");
                    onSelect(appointmentType);
                  }}
                ></Card>
              );
            })}
          </div>
        )}
      </FetchableList>
    </div>
  );
}
